/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class KubernetesCostTrendForecastWidgetConfiguration extends models.KubernetesCostTrendWidgetConfiguration {
    constructor() {
        super();
        this.setDiscriminator("KubernetesCostTrendForecastWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return KubernetesCostTrendForecastWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<KubernetesCostTrendForecastWidgetConfiguration>): KubernetesCostTrendForecastWidgetConfiguration {
        let obj = Object.assign(new KubernetesCostTrendForecastWidgetConfiguration(), model);
        KubernetesCostTrendForecastWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<KubernetesCostTrendForecastWidgetConfiguration>): KubernetesCostTrendForecastWidgetConfiguration {
        if (!model) return null;
        return KubernetesCostTrendForecastWidgetConfiguration.newInstance(<KubernetesCostTrendForecastWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: KubernetesCostTrendForecastWidgetConfiguration) {
        if (!obj) return;

        models.KubernetesCostTrendForecastWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: KubernetesCostTrendForecastWidgetConfiguration): boolean {
        if (models.KubernetesCostTrendWidgetConfiguration.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, KubernetesCostTrendForecastWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
